import LinkPane from "../../../components/linkpane";
import { pageData } from "../../../constants/pagedata";
import {capitalizeFirst} from '../../../utils/utils';
import { makeTaskLink } from "../../../utils/linkbuilder";
import { TaskCreateStatus } from "../tasks";

interface PropsType{createStarted:boolean, taskCreateStatus:TaskCreateStatus, pageSelected:string, contentSelected:string[], taskTitle:string, usermail:string, resetClick:Function}

export const CreateOutcome=function(props:PropsType){
    if(props.createStarted===false)return null;
    if(props.taskCreateStatus===TaskCreateStatus.Default)return null;
    if(props.taskCreateStatus===TaskCreateStatus.Create){
        return <p className="teachers-statusmessage">Creating task ...</p>;
    }
    if(props.taskCreateStatus===TaskCreateStatus.Failed){
        return(
            <>
            <p className="teachers-statusmessage">Create failed</p>
            <br/>
            <button onClick={()=>{props.resetClick()}} className='teachers-taskcreater-button teachers-button'>Reset page</button>
            </>
        )
    }
    if(props.taskCreateStatus===TaskCreateStatus.FailedDelete){
        return(
            <>
            <p className="teachers-statusmessage">Create failed - Delete this task from the list in 'View Tasks'</p>
            <br/>
            <button onClick={()=>{props.resetClick()}} className='teachers-taskcreater-button teachers-button'>Reset page</button>
            </>
        )
    }

    if(props.usermail===null)return <p className="teachers-statusmessage">Not logged in</p>;

    let pageName='';
    let myURL='';
    if(props.pageSelected!==''){
        pageName=capitalizeFirst(pageData[props.pageSelected].pageDir.replace(/-/g, ' '));
        myURL=makeTaskLink(props.pageSelected,props.usermail,props.taskTitle);
    }
    
    let showContentText=props.contentSelected[0]!=='';
    return(
        <div id='teachers-tasks-createoutcome'>
            <hr />
            <h3>Success!</h3>
            <p>Here is a link to your task.  You can share this with your students and ask them to play through the activity.  When students first open the link, they will be asked to enter a username.  This username and the student's score will be recorded on the server.  You can view these records on this page by clicking on the 'Show Tasks' button and then clicking on the task title.</p>
			<LinkPane linkURL={myURL} />
            <p>The title of the task you created is <b>{props.taskTitle}</b></p>
            <p>The page used for your task is <b>{pageName}</b></p>
            {showContentText&&<p>The content used in your task is <b>{props.contentSelected[0]}</b></p>}
            <p>You can view and manage your tasks by clicking on the 'View Tasks' button at the top</p>
            <p>To create another task begin by clicking on the 'Reset Page' button below.</p>
            <br/>
            <button onClick={()=>{props.resetClick()}} className='teachers-taskcreater-button teachers-button'>Reset Page</button>
        </div>
    )
};